const divisionFormDefaultState = {
    round_id: 0,
    name: '',
    message: '',
    error: '',
};

export default (state = divisionFormDefaultState, action) => {
    
    switch (action.type) {

        case 'DIVISION_FORM_UPDATE':
            return {
                ...state,
                [action.field.prop]: action.field.value
            };

        case 'DIVISION_FORM_ERROR':
            return {
                ...state,
                message: '',
                error: action.message
            }

        case 'DIVISION_FORM_SUCCESS':
            return {
                ...state,
                error: '',
                message: action.message
            }

        case 'DIVISION_FORM_RESET':
            return divisionFormDefaultState;

        default:
            return state;
    }
};